import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const names = ['Marcela', 'Joaquín', 'Silvia', 'Carlos', 'Sandra', 'Fernanda', 'Valeria', 'Diego', 'Lucía', 'Martín'];
const cities = ['Córdoba', 'Rosario', 'Buenos Aires', 'Mendoza', 'Tucumán', 'Santa Fe', 'La Plata', 'Salta', 'Bariloche', 'Neuquén', 'Mar del Plata'];
export function PurchasePopup() {
  const [show, setShow] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    const showPopup = () => {
      setCurrentName(names[Math.floor(Math.random() * names.length)]);
      setCurrentCity(cities[Math.floor(Math.random() * cities.length)]);
      setShow(true);
      hideTimeout = setTimeout(() => setShow(false), 5000);
    };
    // First popup after 10s, then every 30s
    const firstTimeout = setTimeout(showPopup, 10000);
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(firstTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div className={`fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl p-4 max-w-xs border-l-4 border-bio-green transition-all duration-300 ${show ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-full pointer-events-none'}`} role="status" aria-live="polite" data-id="element-228">
      <div className="flex gap-3 items-start" data-id="element-229">
        <CheckCircle className="w-5 h-5 text-bio-green flex-shrink-0 mt-0.5" data-id="element-230" />
        <div className="text-sm" data-id="element-231">
          <p className="font-semibold text-carbon" data-id="element-232">
            {currentName} de {currentCity}
          </p>
          <p className="text-gray-600 text-xs" data-id="element-233">acaba de comprar Ciencias 360</p>
        </div>
      </div>
    </div>;
}